/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ArrowCounterClockwise': {
    width: 15,
    height: 14,
    viewBox: '0 0 15 14',
    data: '<path pid="0" d="M4.867 5.567H2V2.7" _stroke="#fff" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"/><path pid="1" d="M4.027 10.973a5.256 5.256 0 100-7.434L2 5.567" _stroke="#fff" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
